import {TomSelectWrapper} from "../../Scalesoft.Shared.FrontEnd/Scripts/TomSelect/TomSelectWrapper";

declare const Cleave;

export default class InputFormat {
    private readonly localization: Localization;

    constructor(localization) {
        this.localization = localization;
    }

    public formatPersonalNumber(container: JQuery): void {
        container.find((".input-personal-number")).each((index, element) => {
            const personalNumberCleave = new Cleave(element,
                {
                    delimiter: "/",
                    blocks: [6, 4],
                    delimiterLazyShow: true,
                });
        });
    }

    public formatPhoneNumber(container: JQuery): void {
        const insuranceCompanySelect = container.find(".phone-number-select");
        const selectEl = insuranceCompanySelect.get(0) as HTMLSelectElement;
        new TomSelectWrapper(this.localization, selectEl, {
            maxItems: 1,
            minCount: 1,
            itemClass: "selected-value",
            render: {
                option: (data, escape) => {
                    return "<div class='d-block option'>" + data.content + "</div>";
                },
                item: (data, escape) => {
                    return "<div>" + data.content + "</div>";
                },
                option_create: null,
                no_results: null,
                not_loading: null,
                optgroup: null,
                optgroup_header: null,
                loading: null,
                dropdown: null,
                loading_more: null,
                no_more_results: null,
            },
        }).initializeTomSelect();

        container.find((".input-phone-number")).each((index, element) => {
            let phoneNumberCleave = new Cleave(element,
                {
                    phone: true,
                    phoneRegionCode: insuranceCompanySelect.val(),
                });
            const inputJq = jq(element);
            insuranceCompanySelect.on("change", () => {
                const selectedOption = insuranceCompanySelect.find(`option[value="${insuranceCompanySelect.val()}"]`);
                phoneNumberCleave.destroy();
                inputJq.val("");
                phoneNumberCleave = new Cleave(element, {
                    phone: true,
                    phoneRegionCode: insuranceCompanySelect.val(),
                    prefix: selectedOption.attr("data-country-prefix"),
                });

            });

            if (inputJq.val() === "") {
                insuranceCompanySelect.trigger("change"); // Trigger change event to init default state
            }
        });
    }

    public formatPostalCode(container: JQuery): void {
        container.find((".input-postal-code")).each((index, element) => {
            const postalCodeCleave = new Cleave(element,
                {
                    delimiter: " ",
                    blocks: [3, 2],
                    delimiterLazyShow: true,
                });
        });
    }
}
